import React, {Component} from "react";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleCheckBox from "../../../../../../modules/SimpleCheckBox";
import SimpleDate from "../../../../../../modules/SimpleDate";
import M from "moment/moment";
import {contructQueryParam, FormatCurrencyRupiah, FormatCurrencyWithoutSymbol} from "../../../../../../Services/Utils";
import * as R from "ramda";
import Api from "../../../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../../../modules/popup/SimpleLoadingOverlay";
import {ACTIVITY_TYPE, HttpStatus} from "../../../../../common/Constants";
import {service} from "../../service";
import NumberFormat from "react-number-format";
import {
    getOverDiscountApprovalCode,
    hasCashTempo,
    hasDibayarRumah,
    isDiscountBelowMinimum,
    isOverDiscount,
    isPromoWithinGracePeriod,
} from "../violationRules";

class SubTabTansaksiDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReadOnlySalesProgram: false,
            nilaiHarusSetor: 0,
            currPaymentType: null
        }
    }

    componentDidMount() {
        const currData = this.props.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
        const currKodeVarian = this.props.data?.dataUnit?.kodeVariant?.value;
        const currIdWarna = this.props.data?.dataUnit?.idWarna?.value;
        const currTypePayment = currData?.tipePayment?.value;
        const currLeasingId = currData?.leasing?.value;

        const isAllPresent = currKodeVarian && currIdWarna;
        let isReadOnly = true;

        if (isAllPresent) {
            if (this.props.state.isEditable) {
                if (currTypePayment === "CREDIT" && currLeasingId) {
                    isReadOnly = false;
                }

                if (currTypePayment === "CASH") {
                    isReadOnly = false;
                }
            }
        }

        this.setState((prevState) => ({
            ...prevState,
            isReadOnlySalesProgram: isReadOnly,
            currPaymentType: currTypePayment,
        }))

        if (currTypePayment) {
            const currHargaDiberikan = this.props.data?.dataTransaction?.headerTransaction?.hargaDiberikan || 0;
            const currBiayaLainlain = currData.biayaLainlain || 0;
            const currDiscountDiberikan = currData.discountDiberikan || 0;
            const currDpPo = currData.dpPo || 0;
            let nilaiHarusSetor;

            if (currTypePayment === "CASH") {
                nilaiHarusSetor = parseInt(currHargaDiberikan) - parseInt(currDiscountDiberikan);
            } else {
                nilaiHarusSetor = parseInt(currDpPo) - parseInt(currDiscountDiberikan);
            }
            if(!currData.tentative){
                nilaiHarusSetor = nilaiHarusSetor + parseInt(currBiayaLainlain);
            }
            this.props.onValueChange("pembayaranKonsumen", "nilaiHarusSetor", nilaiHarusSetor);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const prevData = prevProps.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
        const currData = this.props.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
        const currDataPembayaranKonsumen = this.props.data?.dataTransaction?.detailTransaction?.pembayaranKonsumen;
        const prevDataPembayaranKonsumen = prevProps.data?.dataTransaction?.detailTransaction?.pembayaranKonsumen;

        if (
            prevProps.salesOptions.length !== this.props.salesOptions.length && this.props.salesOptions.length !== 0
        ) {
            this.handleSelectedPromo(
                this.props.activeTab?.value,
                "salesProgramId",
                this.getValue("salesProgramId")
            );
        }

        const prevDiscountMax = prevData.discountMax;
        const currDiscountMax = currData.discountMax;

        const prevDiscountMin = prevData.discountMin;
        const currDiscountMin = currData.discountMin;

        const prevDiscountDiberikan = prevData.discountDiberikan;
        const currDiscountDiberikan = currData.discountDiberikan;

        const prevMk = prevData.mk;
        const prevTk = prevData.tk;
        const currMk = currData.mk;
        const currTk = currData.tk;

        const prevTypePayment = prevData?.tipePayment?.value;
        const currTypePayment = currData?.tipePayment?.value;

        const currDibayarRumah = parseInt(currDataPembayaranKonsumen.dibayarRumah || 0)
        const prevDibayarRumah = parseInt(prevDataPembayaranKonsumen.dibayarRumah || 0)

        const prevCashTempo = parseInt(prevDataPembayaranKonsumen.cashTempo || 0)
        const currCashTempo = parseInt(currDataPembayaranKonsumen.cashTempo || 0)

        const currSalesProgramId = currData.salesProgramId?.value
        const prevSalesProgramId = prevData.salesProgramId?.value

        if(currSalesProgramId !== prevSalesProgramId && currSalesProgramId){
            this.props.handlePelanggaran(
                isPromoWithinGracePeriod(currData.salesProgramId),
                "APPRV0017"
            )
        }

        if(parseInt(prevCashTempo) !== parseInt(currCashTempo)){
            this.props.handlePelanggaran(hasCashTempo(currCashTempo), "APPRV0014")
        }

        if(
            parseInt(prevDiscountMin) !== parseInt(currDiscountMin) || 
            parseInt(prevDiscountDiberikan) !== parseInt(currDiscountDiberikan) ||
            parseInt(prevDiscountMax) !== parseInt(currDiscountMax)
        ){
            this.props.handlePelanggaran(
                isDiscountBelowMinimum(currDiscountDiberikan, currDiscountMin),
                "APPRV0018"
            )
        }

        if(parseInt(currDibayarRumah)!== parseInt(prevDibayarRumah)){
            this.props.handlePelanggaran(hasDibayarRumah(currDibayarRumah), "APPRV0015");
        }
        
        if(
            parseInt(prevDiscountMin) !== parseInt(currDiscountMin) || 
            parseInt(prevDiscountDiberikan) !== parseInt(currDiscountDiberikan) || 
            parseInt(prevMk) !== parseInt(currMk)
        ){
            const isMelanggar = isOverDiscount(
              parseInt(currDiscountDiberikan),
              parseInt(currDiscountMax),
              parseInt(currMk)
            );
            this.props.handlePelanggaran(isMelanggar, this.getKodePelanggaran())
        }

        // if()

        if (!R.equals(prevDiscountMax, currDiscountMax)) {
            this.calculateOverDiscount(currDiscountMax, currDiscountDiberikan, currMk, currTk);
        }

        if (!R.equals(prevDiscountDiberikan, currDiscountDiberikan)) {
            this.calculateOverDiscount(currDiscountMax, currDiscountDiberikan, currMk, currTk);
        }

        if (!R.equals(prevMk, currMk)) {
            this.calculateOverDiscount(currDiscountMax, currDiscountDiberikan, currMk, currTk);
        }
        
        if (!R.equals(prevTk, currTk)) {
            this.calculateOverDiscount(currDiscountMax, currDiscountDiberikan, currMk, currTk);
        }

        let isReadOnly = true;
        if (!R.equals(prevTypePayment, currTypePayment)) {
            const prevKodeVarian = prevProps.data?.dataUnit?.kodeVariant?.value;
            const currKodeVarian = this.props.data?.dataUnit?.kodeVariant?.value;

            const prevIdWarna = prevProps.data?.dataUnit?.idWarna?.value;
            const currIdWarna = this.props.data?.dataUnit?.idWarna?.value;

            const prevLeasingId = prevData?.leasing?.value;
            const currLeasingId = currData?.leasing?.value;

            const hasChanged =
                prevKodeVarian !== currKodeVarian ||
                prevIdWarna !== currIdWarna ||
                prevTypePayment !== currTypePayment ||
                prevLeasingId !== currLeasingId;

            const isAllPresent = currKodeVarian && currIdWarna;
            if (hasChanged && isAllPresent) {
                if (this.props.state.isEditable) {
                    if (currTypePayment === "CREDIT" && !currLeasingId) {
                        isReadOnly = false;
                    }

                    if (currTypePayment === "CASH") {
                        isReadOnly = false;
                    }
                }
            }

            this.setState((prevState) => ({
                ...prevState,
                isReadOnlySalesProgram: isReadOnly,
            }))
        }

        // calculate nilai harus setor
        if (currTypePayment) {
            const prevHargaDiberikan = prevProps.data?.dataTransaction?.headerTransaction?.hargaDiberikan || 0;
            const currHargaDiberikan = this.props.data?.dataTransaction?.headerTransaction?.hargaDiberikan || 0;
            const prevDiscountDiberikan = prevData.discountDiberikan || 0;
            const currDiscountDiberikan = currData.discountDiberikan || 0;
            const prevBiayaLainlain = prevData.biayaLainlain || 0;
            const currBiayaLainlain = currData.biayaLainlain || 0;
            const prevDpPo = prevData.dpPo || 0;
            const currDpPo = currData.dpPo || 0;
            let nilaiHarusSetor = 0;
            const isOk = !R.equals(prevHargaDiberikan, currHargaDiberikan) ||
                !R.equals(prevDiscountDiberikan, currDiscountDiberikan) ||
                !R.equals(prevBiayaLainlain, currBiayaLainlain) ||
                !R.equals(prevDpPo, currDpPo) ||
                !R.equals(prevTypePayment, currTypePayment);

            if (isOk) {
                if (currTypePayment === "CASH") {
                    nilaiHarusSetor = parseInt(currHargaDiberikan) - parseInt(currDiscountDiberikan);
                } else {
                    nilaiHarusSetor = parseInt(currDpPo) - parseInt(currDiscountDiberikan);
                }
                if(!currData.tentative){
                    nilaiHarusSetor = nilaiHarusSetor - parseInt(currBiayaLainlain);
                }
                this.props.onValueChange("pembayaranKonsumen", "nilaiHarusSetor", nilaiHarusSetor);
            }
        }
    }

    getValue = (key) => {
        const {activeTab} = this.props;
        return this.props.getValue(activeTab, key)
    }

    calculateOverDiscount = (discountMax, discountDiberikan, mk, tk) => {
        const activeTab = this.props.activeTab?.value;
        const total = Number(discountDiberikan) + Number(mk) + Number(tk) - discountMax;
        this.props.onValueChange(activeTab, "overDiscount", total < 0 ? 0 : total);
    }

    getIsValidDiscountDiberikan = () => {
        const discountDiberikan = parseInt(this.getValue("discountDiberikan") || 0);
        const discountMax = parseInt(this.getValue("discountMax") || 0);
        const discountMin = parseInt(this.getValue("discountMin") || 0);
        
        return discountDiberikan > discountMax || discountDiberikan < discountMin;
    }

    getKodePelanggaran = () => {
        return getOverDiscountApprovalCode(
            this.props.data.dataTransaction?.headerTransaction?.levelMarketing
        );
    }

    getIsValidOverDiscount = () => {
        const discountDiberikan = parseInt(this.getValue("discountDiberikan") || 0);
        const discountMax = parseInt(this.getValue("discountMax") || 0);
        const mk = parseInt(this.getValue("mk") || 0);
        
        return this.calculateIsOverDiscount(discountDiberikan,discountMax, mk);
    }

    calculateIsOverDiscount = (discDiberikan, discMax, mk) => {
        return isOverDiscount(discDiberikan, discMax, mk);
    }

    getIsValidDibayarRumah = () => {
        const dibayarRumah = parseInt(this.getValue("dibayarRumah") || 0);

        return hasDibayarRumah(dibayarRumah);
    }

    getIsValidCashTempo = () => {
        const cashTempo = parseInt(this.getValue("cashTempo") || 0);
        
        return hasCashTempo(cashTempo);
    }

    calculateTotal = () => {
        const dibayarTunai = parseInt(this.getValue("dibayarTunai") || 0);
        const dibayarTransfer = parseInt(this.getValue("dibayarTransfer") || 0);
        const dibayarRumah = parseInt(this.getValue("dibayarRumah") || 0);
        const cashTempo = parseInt(this.getValue("cashTempo") || 0);
        return dibayarTunai + dibayarTransfer + dibayarRumah + cashTempo;
    }

    calculateSelisih = () => {
        const nilaiHarusSetor = parseInt(this.getValue("nilaiHarusSetor") || 0);
        const total = this.calculateTotal();
        return nilaiHarusSetor - total;
    }

    isAfterEndPromoDate = () => {
        const salesProgramId = this.getValue("salesProgramId");
        
        if (R.isNil(salesProgramId) || R.isEmpty(salesProgramId)) return false;

        return this.props.pelanggaran.includes("APPRV0017") || (new Date() > salesProgramId?.tanggalSelesai && new Date() <= salesProgramId?.gracePeriod);
    };

    handleSelectedPromo = async (tab, name, value) => {
        if (value) {
            this.handleTriggerLoading();
            const dataPembayaranUnit = this.props.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
            const salesPerson = this.props.data?.dataTransaction?.headerTransaction?.salesPersonId;
            const enhancedSalesPerson = this.props.salesOptions.find(item => item.value === salesPerson.value)
            const dataUnit = this.props.data?.dataUnit
            const kodeVariant = dataUnit?.kodeVariant?.value;
            const idWarna = dataUnit?.idWarna?.value;
            const dpPo = dataPembayaranUnit?.dpPo;
            const tenor = dataPembayaranUnit?.tenor;
            const typePayment = dataPembayaranUnit?.tipePayment?.value;

            if((value?.id === undefined || R.isNil(value?.id))){
                this.handleTriggerLoading();
                return;
            }

            if (typePayment === "CREDIT") {
                let res = await Api.create("NAGAMAS_MASTER_DATA").getMasterPromoCreditSalesOrder(contructQueryParam({
                    promoId: value?.value,
                    downPayment: dpPo,
                    tenor: tenor,
                    variantId: kodeVariant,
                    warnaId: idWarna,
                }));

                if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                    const discountMax = service.getDiscountMaxByMarketingLevel(enhancedSalesPerson, res.data.data);
                    this.props.onSetState((prevState) => ({
                        ...prevState,
                        data: {
                            ...prevState.data,
                            dataTransaction: {
                                ...prevState.data.dataTransaction,
                                detailTransaction: {
                                    ...prevState.data.dataTransaction.detailTransaction,
                                    pembayaranUnit: {
                                        ...prevState.data.dataTransaction.detailTransaction.pembayaranUnit,
                                        discountMax: discountMax,
                                        discountMin: res.data.data?.diskonMinimum || 0,
                                        scpAhm: res.data.data?.subsidiAhm,
                                        scpMd: res.data.data?.subsidiMd,
                                        scpDealer: res.data.data?.subsidiDealer,
                                    }
                                }
                            }
                        }
                    }))
                }
            } else if (typePayment === "CASH") {
                const userId = localStorage.getItem("userId");
                let res = await Api.create("NAGAMAS_MASTER_DATA").getByIdMasterPromo({promoId: value?.id, userId: userId});

                if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                    const {detailPromo} = res.data.data;
                    const data = detailPromo && !R.isEmpty(detailPromo) ?
                        detailPromo.find(item => item.variant?.kodeVariant === kodeVariant && item.warna?.warnaResponseDTO?.id === idWarna) : null;

                    if (data) {
                        const discountMax = service.getDiscountMaxByMarketingLevel(enhancedSalesPerson, data);
                        this.props.onSetState((prevState) => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                dataTransaction: {
                                    ...prevState.data.dataTransaction,
                                    detailTransaction: {
                                        ...prevState.data.dataTransaction.detailTransaction,
                                        pembayaranUnit: {
                                            ...prevState.data.dataTransaction.detailTransaction.pembayaranUnit,
                                            discountMax: discountMax,
                                            discountMin: data.diskonMinimum,
                                            scpAhm: data.subsidiAhm,
                                            scpMd: data.subsidiMd,
                                            scpDealer: data.subsidiDealer,
                                        }
                                    }
                                }
                            }
                        }))
                    }
                }
            }

            this.handleTriggerLoading();
        }
        this.props.onValueChange(tab, name, value)
    }

    isReadOnlyForCredit = () => {
        let isReadOnly = true;
        if (this.props.state.isEditable) {
            const currData = this.props.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
            const currTypePayment = currData?.tipePayment?.value;
            isReadOnly = !!(currTypePayment === "CASH" || currTypePayment === undefined || R.isNil(currTypePayment));
        }

        return isReadOnly
    }

    isFieldNeedSalesProgram = () => {
        const currData = this.props.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
        return this.isReadOnly() || !currData?.salesProgramId?.value
    }
    
    isReadOnlyForCreditSpesificField = (isCreditField) => {
        const currData = this.props.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
        const currTypePayment = currData?.tipePayment?.value;
        let isReadOnly = true;
        
        if (this.props.state.isEditableSpesificField) {
            if(isCreditField){
                return currTypePayment === "CASH" || !currTypePayment;
            }
            return !this.props.state.isEditableSpesificField || !currData?.salesProgramId?.value
        }
        if(this.props.state.isReadOnly && !this.props.state.isEditableSpesificField){
            isReadOnly = currTypePayment === "CASH" || !currTypePayment;
            if(!isCreditField){
                isReadOnly = !currData?.salesProgramId?.value
            }
        }

        return isReadOnly
    }

    handleSelectedTipePayment = (tab, name, value) => {
        this.props.onValueChange(tab, name, value)
        if (value?.value === "CASH") {
            this.props.onValueChange(tab, "leasing", null);
            this.props.onValueChange(tab, "dpPo", null);
            this.props.onValueChange(tab, "subsidiUmLeasing", null);
            this.props.onValueChange(tab, "angsuran", null);
            this.props.onValueChange(tab, "tenor", null);
            this.props.onValueChange(tab, "noPo", null);
        }
    }

    isReadOnly = () => {
        let readOnly = true;
        const salesPersonId = this.props.data.dataTransaction?.headerTransaction?.salesPersonId?.value
        if (this.props.state.isEditable && salesPersonId) {
            readOnly = false;
        }

        return readOnly;
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangeNoPo = (activeTab, name, value) => {
        this.props.verifyPoNumberLeasing(value);
        this.props.onValueChange(activeTab, name, value);
    };

    render() {
        const activeTab = this.props.activeTab?.value;
        let {errors,headerTab,data} = this.props;
        const salesProgramId = data?.dataTransaction?.detailTransaction?.pembayaranUnit?.salesProgramId?.value
        const isDGITab = headerTab === 'DGI'
        return (
            <>
                {activeTab === "pembayaranUnit" && (
                    <>
                        <div className="grid grid-2x gap-20px grid-mobile-none">
                            <div id="grid-1">
                                <SimpleDDL
                                    id="select_options_tipe_payment"
                                    name="tipePayment"
                                    label="Tipe Payment"
                                    mandatory
                                    box="search"
                                    isClearable
                                    options={[
                                        {label: "CASH", value: "CASH"},
                                        {label: "CREDIT", value: "CREDIT"},
                                    ]}
                                    readOnly={this.isReadOnly()}
                                    value={this.getValue("tipePayment")}
                                    errorMessage={errors?.["pembayaranUnit"]?.tipePayment}
                                    onChange={(value, {name}) => this.handleSelectedTipePayment(activeTab, name, value)}
                                />
                                <div style={{border: "2px solid grey", padding: "2vh", marginBottom: "2vh"}}>
                                    <SimpleDDL
                                        id="select_options_leasing"
                                        name="leasing"
                                        label="Leasing"
                                        box="search"
                                        mandatory
                                        options={this.props.leasingOptions}
                                        value={this.getValue("leasing")}
                                        readOnly={this.isReadOnlyForCredit()}
                                        onChange={(value, {name}) => this.props.onValueChange(activeTab, name, value)}
                                        errorMessage={errors?.["pembayaranUnit"]?.leasingId}
                                    />
                                    <SimpleInput
                                        id="input_text_dp_po"
                                        box="number"
                                        name="dpPo"
                                        label="DP PO"
                                        mandatory
                                        readOnly={this.isReadOnlyForCredit()}
                                        value={FormatCurrencyWithoutSymbol({number: this.getValue("dpPo")})}
                                        onValueChange={({value}) => this.props.onValueChange(activeTab, "dpPo", value)}
                                        errorMessage={errors?.["pembayaranUnit"]?.dpPo}
                                    />
                                    <SimpleInput
                                        id="input_text_subsidi_um_leasing"
                                        box="number"
                                        name="subsidiUmLeasing"
                                        mandatory
                                        label="Subsidi UM Leasing"
                                        readOnly={isDGITab ? this.isReadOnlyForCredit() : this.isReadOnlyForCreditSpesificField(true)}
                                        value={FormatCurrencyWithoutSymbol({number: this.getValue("subsidiUmLeasing")})}
                                        onValueChange={({value}) => this.props.onValueChange(activeTab, "subsidiUmLeasing", value)}
                                        errorMessage={errors?.["pembayaranUnit"]?.subsidiUmLeasing}
                                    />
                                    <SimpleInput
                                        id="input_text_angsuran"
                                        box="number"
                                        name="angsuran"
                                        label="Angsuran"
                                        mandatory
                                        readOnly={isDGITab ? this.isReadOnlyForCredit() : this.isReadOnlyForCreditSpesificField(true)}
                                        value={FormatCurrencyWithoutSymbol({number: this.getValue("angsuran")})}
                                        onValueChange={({value}) => this.props.onValueChange(activeTab, "angsuran", value)}
                                        errorMessage={errors?.["pembayaranUnit"]?.angsuran}
                                    />
                                    <div className="margin-bottom-20px">
                                        <div className="margin-5px">
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4>Tenor</h4>
                                            </div>
                                        </div>
                                        <FlexView vAlignContent="center" style={{gap: 10}}>
                                            <NumberFormat
                                                id="input_text_tenor"
                                                readOnly={isDGITab ? this.isReadOnlyForCredit() : this.isReadOnlyForCreditSpesificField(true)}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                value={FormatCurrencyWithoutSymbol({number: this.getValue("tenor")})}
                                                style={{backgroundColor: isDGITab ? this.isReadOnlyForCredit() : this.isReadOnlyForCreditSpesificField(true) && "#E6E6E6"}}
                                                type="text"
                                                className="txt txt-sekunder-color"
                                                onValueChange={({value}) => this.props.onValueChange(activeTab, "tenor", value)}
                                            />
                                            <div className="margin-5px">
                                                <div className="txt-site txt-11 txt-main txt-bold">
                                                    <h4>Bulan</h4>
                                                </div>
                                            </div>
                                        </FlexView>
                                        {errors?.["pembayaranUnit"]?.tenor && (
                                            <p className="txt-site txt-11 color-red margin-top-5px">{errors?.["pembayaranUnit"]?.tenor}</p>
                                        )}
                                    </div>
                                    <SimpleInput
                                        id="input_text_no_id_po"
                                        name="noPo"
                                        label="No / Id PO"
                                        mandatory
                                        readOnly={this.isReadOnlyForCredit()}
                                        value={this.getValue("noPo")}
                                        onChange={({target}) => this.handleChangeNoPo(activeTab, target.name, target.value)}
                                        errorMessage={errors?.["pembayaranUnit"]?.noPo}
                                    />
                                    {this.props.isPoExist && <p className="txt-site txt-11">No/Id Po sudah dipakai</p>}
                                </div>

                                <SimpleInput
                                    id="input_text_discount_max"
                                    box="number"
                                    name="discountMax"
                                    label="Discount Max"
                                    readOnly
                                    value={FormatCurrencyWithoutSymbol({number: this.getValue("discountMax")})}
                                />
                                <SimpleInput
                                    id="input_text_discount_min"
                                    box="number"
                                    name="discountMin"
                                    label="Discount Min"
                                    readOnly
                                    value={FormatCurrencyWithoutSymbol({number: this.getValue("discountMin")})}
                                />
                                <FlexView column style={{justifyContent: "space-between", gap: "5px"}}>
                                    <div className="txt-site txt-11 txt-main txt-bold">
                                        <h4>Disc. Diberikan</h4>
                                    </div>
                                    <FlexView
                                        style={{justifyContent: "space-between", gap: "5px", marginBottom: "20px"}}>
                                        <NumberFormat
                                            id="input_text_disc_diberikan"
                                            disabled={this.isReadOnly() || !salesProgramId}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            value={FormatCurrencyWithoutSymbol({number: this.getValue("discountDiberikan")})}
                                            style={{backgroundColor: (this.isReadOnly() || !salesProgramId) && "#E6E6E6"}}
                                            type="text"
                                            className="txt txt-sekunder-color"
                                            onValueChange={({value}) => this.props.onValueChange(activeTab, "discountDiberikan", value)}
                                        />
                                        {this.getIsValidDiscountDiberikan() && (
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4 style={{color: "red"}}>Perlu Approval</h4>
                                            </div>
                                        )}
                                    </FlexView>
                                    {errors?.["pembayaranUnit"]?.discountDiberikan && (
                                        <p className="txt-site txt-11 color-red margin-top-5px">{errors?.["pembayaranUnit"]?.discountDiberikan}</p>
                                    )}
                                </FlexView>
                                <SimpleInput
                                    id="input_text_mk"
                                    box="number"
                                    name="mk"
                                    label="MK"
                                    readOnly={this.isReadOnly() || !salesProgramId}
                                    value={FormatCurrencyWithoutSymbol({number: this.getValue("mk")})}
                                    onValueChange={({value}) => this.props.onValueChange(activeTab, "mk", value)}
                                    errorMessage={errors?.["pembayaranUnit"]?.mk}
                                />
                                <FlexView column
                                          style={{justifyContent: "space-between", gap: "5px", marginBottom: "20px"}}>
                                    <div className="txt-site txt-11 txt-main txt-bold">
                                        <h4>Over Disc</h4>
                                    </div>
                                    <FlexView
                                        style={{justifyContent: "space-between", gap: "5px", marginBottom: "20px"}}>
                                        <NumberFormat
                                            id="input_text_dibayar_dirumah"
                                            disabled={true}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            value={FormatCurrencyWithoutSymbol({number: this.getValue("overDiscount")})}
                                            style={{
                                                backgroundColor: this.getIsValidOverDiscount() && "#E6E6E6"
                                            }}
                                            type="text"
                                            className="txt txt-sekunder-color"
                                        />
                                        {this.getIsValidOverDiscount() && (
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4 style={{color: "red"}}>Perlu Approval</h4>
                                            </div>
                                        )}
                                    </FlexView>
                                </FlexView>
                                <SimpleInput
                                    id="input_text_tk"
                                    box="number"
                                    name="tk"
                                    label="TK"
                                    mandatory
                                    readOnly={this.isReadOnly() || !salesProgramId}
                                    value={FormatCurrencyWithoutSymbol({number: this.getValue("tk")})}
                                    onValueChange={({value}) => this.props.onValueChange(activeTab, "tk", value)}
                                    errorMessage={errors?.["pembayaranUnit"]?.tk}
                                />
                                <SimpleInput
                                    id="input_text_biaya_lain_lain"
                                    box="number"
                                    name="biayaLainlain"
                                    label="Biaya Lain-Lain Dibebankan Konsumen"
                                    readOnly={this.isReadOnly() || !salesProgramId}
                                    mandatory
                                    value={FormatCurrencyWithoutSymbol({number: this.getValue("biayaLainlain")})}
                                    onValueChange={({value}) => this.props.onValueChange(activeTab, "biayaLainlain", value)}
                                    errorMessage={errors?.["pembayaranUnit"]?.biayaLainlain}
                                />
                                <SimpleCheckBox
                                    id="input_check_box_tentative"
                                    name="tentative"
                                    label="Tentative"
                                    disabled={this.isReadOnly() || !salesProgramId}
                                    checked={this.getValue("tentative") || false}
                                    onChange={({target}) => this.props.onValueChange(activeTab, target.name, target.checked)}
                                />
                            </div>
                            <div id="grid-2">
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: "91%",
                                    }}
                                >
                                    <div>
                                        <SimpleDDL
                                            id="select_options_sales_program"
                                            name="salesProgramId"
                                            label="Sales Program"
                                            mandatory
                                            box="search"
                                            isClearable
                                            options={this.props.promoOptions || []}
                                            readOnly={this.state.isReadOnlySalesProgram}
                                            value={this.getValue("salesProgramId")}
                                            errorMessage={errors?.["pembayaranUnit"]?.salesProgramId}
                                            onChange={(value, {name}) => this.handleSelectedPromo(activeTab, name, value)}
                                        />
                                        {this.isAfterEndPromoDate() && (
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4 style={{color: "red"}}>promo memasuki grace period - perlu approval</h4>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{border: "2px solid grey", padding: "2vh", marginBottom: "2vh"}}>
                                        <SimpleInput
                                            id="input_text_scp_ahm"
                                            box="number"
                                            name="scpAhm"
                                            label="SCP AHM"
                                            mandatory
                                            errorMessage={errors?.["pembayaranUnit"]?.scpAhm}
                                            readOnly={isDGITab ? this.isFieldNeedSalesProgram() : this.isReadOnlyForCreditSpesificField()}
                                            value={FormatCurrencyWithoutSymbol({number: this.getValue("scpAhm")})}
                                            onValueChange={({value}) => this.props.onValueChange(activeTab, "scpAhm", value)}
                                        />
                                        <SimpleInput
                                            id="input_text_scp_md"
                                            box="number"
                                            name="scpMd"
                                            label="SCP MD"
                                            mandatory
                                            errorMessage={errors?.["pembayaranUnit"]?.scpMd}
                                            readOnly={isDGITab ? this.isFieldNeedSalesProgram() : this.isReadOnlyForCreditSpesificField()}
                                            value={FormatCurrencyWithoutSymbol({number: this.getValue("scpMd")})}
                                            onValueChange={({value}) => this.props.onValueChange(activeTab, "scpMd", value)}
                                        />
                                        <SimpleInput
                                            id="input_text_scp_dealer"
                                            box="number"
                                            name="scpDealer"
                                            label="SCP Dealer"
                                            mandatory
                                            errorMessage={errors?.["pembayaranUnit"]?.scpDealer}
                                            readOnly={isDGITab ? this.isFieldNeedSalesProgram() : this.isReadOnlyForCreditSpesificField()}
                                            value={FormatCurrencyWithoutSymbol({number: this.getValue("scpDealer")})}
                                            onValueChange={({value}) => this.props.onValueChange(activeTab, "scpDealer", value)}
                                        />
                                        <SimpleInput
                                            id="input_text_subsidi_lain"
                                            box="number"
                                            name="subsidiLain"
                                            label="Subsidi Lain"
                                            mandatory
                                            errorMessage={errors?.["pembayaranUnit"]?.subsidiLain}
                                            readOnly={isDGITab ? this.isFieldNeedSalesProgram() : this.isReadOnlyForCreditSpesificField()}
                                            value={FormatCurrencyWithoutSymbol({number: this.getValue("subsidiLain")})}
                                            onValueChange={({value}) => this.props.onValueChange(activeTab, "subsidiLain", value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {activeTab === "dataTransaksiTambahan" && (
                    <>
                        <div className="grid grid-2x gap-20px grid-mobile-none">
                            <div id="grid-1">
                                <SimpleInput
                                    id="input_text_promo_id_ahm"
                                    name="promoIdAhm"
                                    label="Promo ID AHM"
                                    readOnly={this.props.state.activityType === ACTIVITY_TYPE.UPDATE ? false : this.isReadOnly()}
                                    value={this.getValue("promoIdAhm")}
                                    onChange={({target}) => this.props.onValueChange(activeTab, target.name, target.value)}
                                />
                                <SimpleDDL
                                    id="select_options_ppn"
                                    name="ppn"
                                    box="search"
                                    label="PPN"
                                    disabled={this.isReadOnly()}
                                    isClearable
                                    styles={{width: "80%"}}
                                    options={
                                        this.props.taxOptions.map(item => ({
                                            value: item.value,
                                            label: item.label + " %"
                                        }))
                                    }
                                    value={this.getValue("ppn")}
                                    onChange={(value, {name}) => this.props.onValueChange(activeTab, name, value)}
                                />
                            </div>
                            <div id="grid-2"></div>
                        </div>
                    </>
                )}

                {activeTab === "pembayaranKonsumen" && (
                    <>
                        <div className="grid grid-2x gap-20px grid-mobile-none">
                            <div id="grid-1">
                                <SimpleInput
                                    id="input_text_nilai_harus_setor"
                                    box="onlyNumber"
                                    name="nilaiHarusSetor"
                                    label="Nilai Harus Setor"
                                    readOnly
                                    value={FormatCurrencyRupiah({number: this.getValue("nilaiHarusSetor")})}
                                />
                                <SimpleInput
                                    id="input_text_selisih"
                                    box="onlyNumber"
                                    name="selisih"
                                    label="Selisih"
                                    readOnly
                                    value={FormatCurrencyRupiah({number: this.calculateSelisih()})}
                                />
                            </div>
                            <div id="grid-2">
                                <SimpleInput
                                    id="input_text_dibayar_tunai"
                                    box="number"
                                    name="dibayarTunai"
                                    label="Dibayar Tunai"
                                    mandatory
                                    readOnly={this.isReadOnly()}
                                    value={FormatCurrencyWithoutSymbol({number: this.getValue("dibayarTunai")})}
                                    onValueChange={({value}) => this.props.onValueChange(activeTab, "dibayarTunai", value)}
                                    errorMessage={errors?.["pembayaranKonsumen"]?.dibayarTunai}
                                />
                                <SimpleInput
                                    id="input_text_dibayar_transfer"
                                    box="number"
                                    name="dibayarTransfer"
                                    label="Dibayar Transfer"
                                    mandatory
                                    readOnly={this.isReadOnly()}
                                    value={FormatCurrencyWithoutSymbol({number: this.getValue("dibayarTransfer")})}
                                    onValueChange={({value}) => this.props.onValueChange(activeTab, "dibayarTransfer", value)}
                                    errorMessage={errors?.["pembayaranKonsumen"]?.dibayarTransfer}
                                />
                                <SimpleDDL
                                    id="select_options_nama_paket"
                                    styles={{width: "30%"}}
                                    name="bank"
                                    placeholder="Pilih Bank"
                                    label="Pilih Bank"
                                    box="search"
                                    options={this.props.bankOptions}
                                    mandatory={typeof parseInt(this.getValue("dibayarTransfer")) === 'number' &&  parseInt(this.getValue("dibayarTransfer")) > 0}
                                    isClearable
                                    readOnly={this.isReadOnly()}
                                    value={this.getValue("bank")}
                                    onChange={(value, {name}) => this.props.onValueChange(activeTab, name, value)}
                                    errorMessage={errors?.["pembayaranKonsumen"]?.bankId}
                                />
                                <FlexView column
                                          style={{justifyContent: "space-between", gap: "5px", marginBottom: "20px"}}>
                                    <div className="txt-site txt-11 txt-main txt-bold">
                                        <h4>Dibayar Rumah <span style={{color: "red"}}>*</span></h4>
                                    </div>
                                    <FlexView
                                        style={{justifyContent: "space-between", gap: "5px", marginBottom: "20px"}}>
                                        <NumberFormat
                                            id="input_text_dibayar_dirumah"
                                            disabled={this.isReadOnly()}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            value={FormatCurrencyWithoutSymbol({number: this.getValue("dibayarRumah")})}
                                            style={{backgroundColor: this.isReadOnly() && "#E6E6E6"}}
                                            type="text"
                                            className="txt txt-sekunder-color"
                                            onValueChange={({value}) => this.props.onValueChange(activeTab, "dibayarRumah", value)}
                                        />
                                        {this.getIsValidDibayarRumah() && (
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4 style={{color: "red"}}>Perlu Approval</h4>
                                            </div>
                                        )}
                                    </FlexView>
                                    {errors?.["pembayaranKonsumen"]?.dibayarRumah && (
                                        <p className="txt-site txt-11 color-red margin-top-5px">{errors?.["pembayaranKonsumen"]?.dibayarRumah}</p>
                                    )}
                                </FlexView>
                                <FlexView column
                                          style={{justifyContent: "space-between", gap: "5px", marginBottom: "20px"}}>
                                    <div className="txt-site txt-11 txt-main txt-bold">
                                        <h4>Cash Tempo {this.state.currPaymentType !== "CREDIT" &&
                                            <span style={{color: "red"}}>*</span>}</h4>
                                    </div>
                                    <FlexView
                                        style={{justifyContent: "space-between", gap: "5px", marginBottom: "20px"}}>
                                        <NumberFormat
                                            id="input_text_cash_tempo"
                                            disabled={this.isReadOnly() || this.state.currPaymentType === "CREDIT"}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            value={FormatCurrencyWithoutSymbol({number: this.getValue("cashTempo")})}
                                            style={{backgroundColor: (this.isReadOnly() || this.state.currPaymentType === "CREDIT") && "#E6E6E6"}}
                                            type="text"
                                            className="txt txt-sekunder-color"
                                            onValueChange={({value}) => this.props.onValueChange(activeTab, "cashTempo", value)}
                                        />
                                        {this.getIsValidCashTempo() && (
                                            <div className="txt-site txt-11 txt-main txt-bold">
                                                <h4 style={{color: "red"}}>Perlu Approval</h4>
                                            </div>
                                        )}
                                    </FlexView>
                                    {errors?.["pembayaranKonsumen"]?.cashTempo && (
                                        <p className="txt-site txt-11 color-red margin-top-5px">{errors?.["pembayaranKonsumen"]?.cashTempo}</p>
                                    )}
                                </FlexView>
                                <SimpleDate
                                    id="input_date_tgl_deadline_tempo"
                                    name="tanggalDeadlineTempo"
                                    label="Tgl. Deadline Tempo"
                                    mandatory={typeof parseInt(this.getValue("cashTempo")) === 'number' && this.state.currPaymentType !== "CREDIT"}
                                    disabled={this.isReadOnly() || this.state.currPaymentType === "CREDIT"}
                                    date={this.getValue("tanggalDeadlineTempo")}
                                    onChange={(value) => this.props.onValueChange(activeTab, "tanggalDeadlineTempo", M(value).format("DD-MM-YYYY"))}
                                    errorMessage={errors?.["pembayaranKonsumen"]?.tanggalDeadlineTempo}
                                />
                                <div className="margin-5px">
                                    <div className="txt-site txt-16 txt-main txt-bold">
                                        <h4>Total</h4>
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    name="total"
                                    className="txt txt-sekunder-color"
                                    disabled
                                    style={{
                                        fontSize: 24
                                    }}
                                    value={FormatCurrencyRupiah({number: this.calculateTotal()})}
                                />
                            </div>
                        </div>
                    </>
                )}

                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

export default SubTabTansaksiDetail;
